import _extends from "@babel/runtime/helpers/esm/extends";
import { useTheme } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Button } from '../../Button';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function BodyContent(_ref) {
  var _ref$convertTxtToBlue = _ref.convertTxtToBlue,
    convertTxtToBlue = _ref$convertTxtToBlue === void 0 ? function () {
      return false;
    } : _ref$convertTxtToBlue,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    headerText = _ref.headerText,
    primaryButtonProps = _ref.primaryButtonProps,
    secondaryButtonProps = _ref.secondaryButtonProps,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    subHeaderText = _ref.subHeaderText,
    summary = _ref.summary,
    supportingText = _ref.supportingText,
    text = _ref.text,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Icon simple' : _ref$type,
    value = _ref.value;
  var theme = useTheme();
  return /*#__PURE__*/_jsx(_Fragment, {
    children: type !== 'Icon card' ? /*#__PURE__*/_jsxs(Stack, {
      spacing: type === 'Payment icon' ? 2 : 0,
      children: [/*#__PURE__*/_jsxs(Stack, {
        columnGap: "4px",
        flexDirection: type !== 'Payment icon' ? 'row' : 'column',
        children: [/*#__PURE__*/_jsx(Typography, {
          color: !disabled && convertTxtToBlue(value) ? theme.palette.primary[800] : theme.palette.gray[700],
          component: "span",
          variant: size === 'md' ? 'text-md-medium' : 'text-sm-medium',
          children: headerText
        }), /*#__PURE__*/_jsx(Typography, {
          color: !disabled && convertTxtToBlue(value) ? theme.palette.primary[700] : theme.palette.gray[600],
          component: "span",
          variant: size === 'md' ? 'text-md-regular' : 'text-sm-regular',
          children: subHeaderText
        })]
      }), summary && type !== 'Payment icon' && /*#__PURE__*/_jsx(Typography, {
        color: !disabled && convertTxtToBlue(value) ? theme.palette.primary[700] : theme.palette.gray[600],
        component: "p",
        variant: size === 'md' ? 'text-md-regular' : 'text-sm-regular',
        children: summary
      }), type === 'Payment icon' && /*#__PURE__*/_jsxs(Stack, {
        columnGap: "12px",
        flexDirection: "row",
        sx: {
          mt: '8px'
        },
        children: [secondaryButtonProps && /*#__PURE__*/_jsx(Button, _extends({}, secondaryButtonProps, {
          size: size === 'md' ? 'medium' : 'small',
          variant: !disabled && convertTxtToBlue(value) ? 'link' : 'link-gray',
          children: secondaryButtonProps.children
        })), primaryButtonProps && /*#__PURE__*/_jsx(Button, _extends({}, primaryButtonProps, {
          size: size === 'md' ? 'medium' : 'small',
          variant: "link",
          children: primaryButtonProps.children
        }))]
      })]
    }) : /*#__PURE__*/_jsxs(Stack, {
      children: [/*#__PURE__*/_jsxs(Stack, {
        alignItems: "baseline",
        columnGap: "4px",
        flexDirection: "row",
        children: [/*#__PURE__*/_jsx(Typography, {
          color: theme.palette.gray[700],
          component: "span",
          variant: size === 'md' ? 'display-md-semibold' : 'display-sm-semibold',
          children: text
        }), /*#__PURE__*/_jsx(Typography, {
          color: theme.palette.gray[600],
          component: "span",
          variant: size === 'md' ? 'text-md-regular' : 'text-sm-regular',
          children: supportingText
        })]
      }), /*#__PURE__*/_jsx(Typography, {
        color: theme.palette.gray[600],
        component: "p",
        variant: size === 'md' ? 'text-md-regular' : 'text-sm-regular',
        children: summary
      })]
    })
  });
}